module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.displayError) ? _c('p', {
    staticClass: "error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.recurrentServices), function(service) {
    return _c('li', {
      key: service.id,
      staticClass: "service-item",
      class: {
        'deactivated-service-item': _vm.date_is_past(service.activeto)
      }
    }, [_c('div', {
      staticClass: "service-item-type service-icon",
      class: {
        'icon-internet': service.type == 'internet',
          'icon-telefon': service.type == 'telefon',
          'icon-televize': service.type == 'televize',
          'icon-contract': service.type == 'pronájem/zápůjčka',
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "service-item-meat"
    }, [_vm._v("\n        Tarif:\n        "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_c('b', [_vm._v(_vm._s(service.service_name))])]), _vm._v(" "), (service.phone_number) ? _c('span', [_vm._v("číslo: "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(service.phone_number))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (service.value !== null) ? _c('span', [_vm._v("\n          Cena:\n          "), (service.vdiscount1 > 0 || (service.vdiscount2 > 0 && _vm.discount2ValidToDate(service))) ? _c('span', [_c('span', {
      staticClass: "price-before-discount"
    }, [_vm._v(_vm._s(service.value))]), _vm._v(" "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_c('b', [_vm._v(_vm._s((service.value - service.vdiscount1 - _vm.discount2ValueToday(service)).toFixed(2)))]), _vm._v(" Kč\n            ")]), _vm._v(" "), (service.vdiscount1 > 0) ? _c('i', [_vm._v("\n              (sleva " + _vm._s(_vm.prachy(service.vdiscount1)) + " Kč)\n            ")]) : _vm._e(), _vm._v(" "), ((service.vdiscount2 > 0 && _vm.discount2ValidToDate(service))) ? _c('i', [_vm._v("\n              (sleva " + _vm._s(_vm.prachy(service.vdiscount2)) + " Kč"), (service.vdiscount2_end_date) ? _c('span', [_vm._v(" do " + _vm._s(_vm.human_readable_date(service.vdiscount2_end_date)))]) : _vm._e(), _vm._v(")\n            ")]) : _vm._e()]) : _c('span', [_c('span', {
      staticClass: "service-item-highlight"
    }, [_c('b', [_vm._v(_vm._s(_vm.prachy(service.value)))]), _vm._v(" Kč\n            ")])]), _vm._v("\n          " + _vm._s(({
      3: 'měsíčně',
      4: 'čtvrtletně',
      5: 'ročně',
      7: 'půlročně'
    })[service.period]) + "\n          "), _c('span', {
      staticClass: "vat-text"
    }, [_vm._v("\n            " + _vm._s(({
      INCL: 'včetně DPH',
      EXCL: 'bez DPH',
      NONE: ''
    })[service.vat_type]) + "\n            "), (service.vat_type != 'NONE') ? _c('span', [_vm._v(_vm._s(service.vat_rate) + "%")]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v("\n        Lokalita:\n        "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(_vm.human_readable_adr(service)))]), _vm._v(" "), (service.activefrom || service.activeto) ? _c('span', [_c('br'), _vm._v("\n          Aktivní\n          "), (service.activefrom) ? _c('span', [_vm._v(" od "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(_vm.human_readable_date(service.activefrom)))])]) : _vm._e(), _vm._v(" "), (service.activeto) ? _c('span', {
      class: {
        'yellow-highlight': _vm.date_within_month(service.activeto)
      }
    }, [_vm._v(" do "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(_vm.human_readable_date(service.activeto)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((service.billingfrom || service.billingto) && (service.billingfrom != service.activefrom || service.billingto != service.activeto)) ? _c('span', [_c('br'), _vm._v("\n          Účtováno\n          "), (service.billingfrom) ? _c('span', [_vm._v(" od "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(_vm.human_readable_date(service.billingfrom)))])]) : _vm._e(), _vm._v(" "), (service.billingto) ? _c('span', [_vm._v(" do "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(_vm.human_readable_date(service.billingto)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "zpusob-uctovani",
      class: {
        'uctovani-pozastaveno': service.suspended
      }
    }, [_vm._v("\n          Způsob účtování:\n          "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(service.billingplan_name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(service.billingplan_description) + ")")]), _vm._v(" "), (service.billingplan_with_invoice) ? _c('span', [_vm._v("+ vystavit fakturu")]) : _vm._e(), _vm._v(" "), (service.note) ? _c('span', [_c('br'), _vm._v("\n            Poznámka: " + _vm._s(service.note) + "\n          ")]) : _vm._e()]), _vm._v(" "), (service.type == 'televize' && service.techtype == 76 && service.kukiid && !_vm.date_is_past(service.activeto)) ? _c('div', {
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n          Kuki ID: "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(service.kukiid))]), _c('br'), _vm._v("\n          Heslo: "), _c('span', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(service.kukipassword))])]) : _vm._e(), _vm._v(" "), (service.type == 'telefon' && service.techtype == 75) ? _c('div', {
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_c('ipex-cdrfiles-links', {
      attrs: {
        "number": service.phone_number
      }
    })], 1) : _vm._e(), _vm._v(" "), (service.suspended) ? _c('div', {
      staticClass: "alert alert-danger",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n          služba je dočasně pozastavena\n        ")]) : _vm._e()])])
  })), _vm._v(" "), (_vm.onetimeServices && _vm.onetimeServices.length) ? _c('section', [_c('p', [_vm._v("JEDNORÁZOVÉ SLUŽBY")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.onetimeServices), function(os) {
    return _c('tr', {
      key: os.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(_vm.human_readable_date(os.activefrom)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "money"
    }, [(os.value !== null) ? _c('span', [_c('div', [_vm._v(_vm._s(_vm.prachy(os.value)) + " Kč")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(({
      INCL: 'včetně DPH',
      EXCL: 'bez DPH',
      NONE: ''
    })[os.vat_type]))])]) : _c('span', [_vm._v("\n              -\n            ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "service-item-highlight"
    }, [_vm._v(_vm._s(os.service_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(os.note))])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.recurrentServices !== null && _vm.recurrentServices.length == 0 && _vm.onetimeServices !== null && _vm.onetimeServices.length == 0) ? _c('section', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      žádné služby\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n            datum\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "money"
  }, [_vm._v("\n            cena\n          ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "75%"
    }
  }, [_vm._v("\n            popis\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b34b13a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyServices.vue
// module id = 310
// module chunks = 1 2